import React, { type FunctionComponent } from 'react'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import { useEmailVerificationDetails } from 'domains/public/components/email-verification/hooks/publicEmailVerification.hooks'
import { LinkButton } from 'gin-and-tonic/routing/link-button/LinkButton'
import { PublicLayout } from 'domains/public/components/layout/PublicLayout'

interface Props extends DashRouteComponentProps<{ token: string }> {}

export const PublicEmailVerification: FunctionComponent<Props> = ({
  match: {
    params: { token },
  },
}) => {
  const { emailVerificationLoading, emailVerificationSuccess, errorMessageId } =
    useEmailVerificationDetails({
      token,
    })

  const testId = 'public-email-verification-layout'

  if (emailVerificationLoading) {
    return null
  }

  if (emailVerificationSuccess) {
    return (
      <PublicLayout
        headerMessageId="public.emailVerification.header"
        contentMessageId="public.emailVerification.content.success"
        data-testid={testId}
      >
        <LinkButton
          messageId="public.emailVerification.successAction"
          toRoute="app-halt-redirect"
          data-testid="public-email-verification-success-action-button"
        />
      </PublicLayout>
    )
  }

  if (errorMessageId) {
    return (
      <PublicLayout
        headerMessageId="public.emailVerification.header"
        contentMessageId={errorMessageId}
        data-testid={testId}
      >
        <LinkButton
          messageId="public.emailVerification.errorAction"
          toRoute="public-request-email-verification"
          data-testid="public-email-verification-error-action-button"
        />
      </PublicLayout>
    )
  }

  // Shouldn't hit this code path
  return null
}
